// Module
var code = "<div class=\"vessel-event-icon\" data-bind=\"event: { mouseover: showNameToopltip, mouseout: closeTooltip}\">\r\n    <img style=\"margin-bottom: -5px;\" data-bind=\"attr: { src: typeImageSrc }\">\r\n    <!-- ko if: showText -->\r\n    <span data-bind=\"text: typeText\"></span>\r\n    <!-- /ko -->\r\n</div>\r\n";
// Exports
module.exports = code;